/* VYORO WhatsApp hard-direct handler — cache-busted asset */
(function () {
  'use strict';
  function buildUrl(link) {
    var number = (link.getAttribute('data-whatsapp-number') || '917388844184').replace(/\D/g, '');
    var greeting = link.getAttribute('data-whatsapp-greeting') || 'Hello VYORO, I am interested in a bulk deal. Please share the best price and availability.';
    var closing = link.getAttribute('data-whatsapp-closing') || 'Please share bulk pricing and availability.';
    var product = link.getAttribute('data-whatsapp-product') || '';
    var sku = link.getAttribute('data-whatsapp-sku') || '';
    var quantity = link.getAttribute('data-whatsapp-quantity') || '1';
    var productUrl = link.getAttribute('data-whatsapp-url') || '';
    var lines = [greeting];
    if (product) lines.push('Product: ' + product);
    if (sku) lines.push('SKU: ' + sku);
    lines.push('Quantity: ' + quantity);
    if (productUrl) lines.push('Link: ' + productUrl);
    if (closing) lines.push('', closing);
    return 'https://web.whatsapp.com/send?phone=' + number + '&text=' + encodeURIComponent(lines.join('\n'));
  }

  function bind(root) {
    root.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-whatsapp-cta]');
      if (!link) return;
      var url = buildUrl(link);
      link.setAttribute('href', url);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
      /* Let Shopify Theme Editor do its normal "open external link" flow,
         but guarantee the URL is the direct WhatsApp Web endpoint. */
    }, true);
  }

  function init() {
    bind(document);
    document.querySelectorAll('[data-whatsapp-cta]').forEach(function (link) {
      link.setAttribute('href', buildUrl(link));
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
